import { ContactModel } from "./contact.model";
import { SalesModel } from "./sales.model";
import * as yup from "yup";

export interface PaymentModel {
    id?: number | null;
    receiptNumber?: number | null;
    created_by?: number | null
    updated_by?: number | null
    created_at?: Date | null
    updated_at?: Date | null
    paidAmount: number | null
    paidAmountShow: number | null
    basicAmount: number | null
    pendingAmount: number | null
    pendingAmountShow: number | null
    gstCharges: number | null
    otherCharges: number | null
    dateAndTime: string | Date | null;
    paymentMode: string | null
    dueDate: string | Date | null;
    flatId?: number | null
    flat?: any | null
    salesId?: number | null
    sales?: SalesModel | null
    contactName: string | null
    contactNameShow: string | null
    refNo: string | null
    invoiceNumber: number | null
    invoiceNumberShow: number | null
    mobileNo: number | null
    blockNumber: number | null
    blockNumberShow: number | null
    totalAmount: number | null
    totalAmountShow: number | null
    invoiceDate: string | Date | null
    invoiceDateShow: string | Date | null
    name: string | null
    salesAmount: number | null
    receivedAmount: number | null
}

export class PaymentClass implements PaymentModel {
    constructor(data?: any) {
        if (data) {
            this.id = this.id
            this.paidAmount = parseFloat(data.paidAmount)
            this.receiptNumber = Number(data.receiptNumber)
            this.paidAmountShow = data.paidAmountShow
            this.basicAmount = parseFloat(data.basicAmount)
            this.pendingAmount = data.pendingAmount
            this.pendingAmountShow = data.pendingAmountShow
            this.created_at = data.created_at
            this.gstCharges = parseFloat(data.gstCharges)
            this.otherCharges = parseFloat(data.otherCharges)
            this.dateAndTime = data.dateAndTime
            this.paymentMode = data.paymentMode
            this.dueDate = data.dueDate
            this.flatId = data.flatId
            this.flat = data.flat
            this.salesId = data.salesId
            this.sales = data.sales
            this.contactName = data.contactName
            this.contactNameShow = data.contactNameShow
            this.refNo = data.refNo
            this.invoiceNumber = data.invoiceNumber
            this.invoiceNumberShow = data.invoiceDateShow
            this.mobileNo = data.mobileNo
            this.blockNumber = data.blockNumber
            this.blockNumberShow = data.blockNumberShow
            this.totalAmount = data.totalAmount
            this.totalAmountShow = data.totalAmountShow
            this.invoiceDate = data.invoiceNumber
            this.invoiceDateShow = data.invoiceDateShow
            this.name = data.name
        }
    }
    id?= null
    receiptNumber?: any = Number()
    paidAmount: number | null = 0
    paidAmountShow = null
    basicAmount: any = null
    pendingAmount = null
    pendingAmountShow = null
    created_at?= null
    gstCharges: any = null
    otherCharges: any = null
    dateAndTime = null;
    paymentMode = null
    dueDate = null;
    flatId?= null
    flat?= null
    salesId?= null
    sales?= null
    contactName = null
    contactNameShow = null
    refNo = null
    invoiceNumber = null
    invoiceNumberShow = null
    mobileNo = null
    blockNumber = null
    blockNumberShow = null
    totalAmount = null
    totalAmountShow = null
    invoiceDate = null
    invoiceDateShow = null
    name = null
    salesAmount = null
    receivedAmount = null
}

export const pendingAmount = (PaymentModel: PaymentModel) => {
    let total = 0
    total = (Number(PaymentModel.totalAmountShow)) - (Number(PaymentModel.paidAmountShow))
    return (total > 0 ? total : 0);
}

export const receivedAmount = (PaymentModel: PaymentModel) => {
    let total = 0
    total = (Number(PaymentModel.basicAmount))
        + (Number(PaymentModel.gstCharges))
        + (Number(PaymentModel.otherCharges))
    return total;
}


export const paymentValidationSchema = {
    contactName: yup.string().required("Name is required").nullable(),
    receiptNumber: yup.number().required("ReceiptNumber is required").nullable(),
    basicAmount: yup.number().required("BasicAmount is required").nullable(),
    otherCharges: yup.number().required("BasicAmount is required").nullable(),
    gstCharges: yup.number().required("GstCharges is required").nullable(),
    paymentMode: yup.string().required("PaymentMode is required").nullable(),
    created_at: yup.string().required("Date is required").nullable(),
}